/* eslint-disable no-underscore-dangle */
import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import I18NextXhrBackend from 'i18next-xhr-backend';
import { STATIC_PUBLIC_PATH, getAssetsDomain } from 'app-config/webpack/paths';
import enUS from 'date-fns/locale/en-US';

const dateFnsLoadedLocales = {
  en: enUS,
};

async function changeLanguage(language) {
  const shortLanguage = language.substr(0, 2);
  if (!i18n.getDataByLanguage(shortLanguage)) {
    await i18n.loadLanguages(shortLanguage);
    dateFnsLoadedLocales[shortLanguage] = await import(
      /* webpackChunkName: "date-fns-" */ `date-fns/locale/${shortLanguage}/index.js`
    )
      .catch(() =>
        import(/* webpackChunkName: "date-fns-" */ `date-fns/locale/${language}/index.js`),
      )
      .then((module) => module.default)
      .catch(() => null); // ignore error
  }
  // to be used when formating locale sentitive dates
  global.dateFnsLocale = dateFnsLoadedLocales[shortLanguage] || dateFnsLoadedLocales.en;
  return i18n.changeLanguage(shortLanguage);
}

async function initialize() {
  await i18n
    .use(I18NextXhrBackend)
    .use(reactI18nextModule)
    .init({
      lng: 'en',
      interpolation: {
        escapeValue: false, // react already safes from xss
        prefix: '{',
        suffix: '}',
      },
      fallbackLng: 'en',
      backend: {
        loadPath: `${getAssetsDomain()}${STATIC_PUBLIC_PATH}i18n/{lng}/{ns}.json`,
      },
    });

  const intialLanguage = navigator.language || navigator.userLanguage;
  await changeLanguage(intialLanguage);
}

initialize().catch(console.error);

export { i18n, changeLanguage };
